// The visible choice is authoritative even when the subscription app loads late.
(() => {
  const choiceFor = (form) => form?.querySelector('[data-aloe-purchase-options] input[name="aloe_purchase_plan"]:checked');
  const synchronize = (form) => {
    const choice = choiceFor(form);
    if (!choice) return;
    let fields = [...form.querySelectorAll('input[name="selling_plan"]')];
    if (!fields.length) {
      const field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'selling_plan';
      form.append(field);
      fields = [field];
    }
    fields.forEach((field) => { field.value = choice.value; });
  };
  document.addEventListener('change', (event) => {
    if (event.target?.name === 'aloe_purchase_plan') synchronize(event.target.closest('form'));
  }, true);
  document.addEventListener('submit', (event) => synchronize(event.target), true);
  document.addEventListener('formdata', (event) => {
    const choice = choiceFor(event.target);
    if (!choice) return;
    if (choice.value) event.formData.set('selling_plan', choice.value);
    else event.formData.delete('selling_plan');
  }, true);
})();
